import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity CordwoodHistories


export interface CordwoodHistory {
    id: ID;

    
    cordwoodId: ID;

    
    action: string;

    
    contextHistory?: string;

    
    updatedAt: Date;

    
    internalKey: string;

    
    timberKey: string;

    
    storageId: ID;

    
    locationId: ID;

    
    cuttingId: ID;

    
    shipmentId?: ID;

    
    volume: number;

    
    state?: ShipmentState;

    
    measurementType: CordwoodMeasurementType;

    
    timberTypeId: ID;

    
    classId: ID;

    
    commited: boolean;

    
    scopeGroupId: ID;

    
    siteId?: string;

    
    localCreatedAt: Date;

    }

export interface FilterByContextRequest {
    list: ListRequest,
    filter: {
        
            cuttingId?: ID,
        
    
    

            action?: string,
        
    
    

            contextHistory?: string,
        
    
    contextHistoryInclude: boolean,



        cordwoodIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateCordwoodHistory {
    
    cordwoodId: ID;

    
    action: string;

    
    contextHistory?: string;

    
    
    
    
    
    
    
    
    
    state?: ShipmentState;

    
    
    
    
    
    
    
    }



export interface PresentationCordwoodHistoryRequest {
    list: ListRequest,
    filter: {
        cordwoodId: ID,
        cordwoodIdOr: boolean,
        action: string,
        actionOr: boolean,
        cordwoodIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryCordwoodHistory {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: CordwoodHistory): PrimaryCordwoodHistory | undefined {
        return entity ? new PrimaryCordwoodHistory(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryCordwoodHistory {
        return new PrimaryCordwoodHistory(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryCordwoodHistory {
        let vals = path?.split('/');
        return new PrimaryCordwoodHistory(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryCordwoodHistory[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: CordwoodHistory): string {
    let fields = entity ? [
    entity.cordwoodId,
            entity.action,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


